import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const militaryProgramId = '6054c8bdbbcc170065c8892c';
export const stateDepartmentProgramId = '6054c8d3bbcc170065c88b37';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
    urlMilitaryFaq: 'https://support.google.com/fi/answer/10448622',
    urlMemberFaq: 'https://support.google.com/fi/answer/10448622',
    privacyPolicyUrl: 'https://www.sheerid.com/privacy-policy/',
};
